const generateFormLeaveType = [
  {
    label: "ชื่อรูปแบบ", // i18n-ignore: translated by FormComponent
    name: "leave_type_name",
    placeholder: "ป้อนชื่อรูปแบบ", // i18n-ignore: translated by FormComponent
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    defaultOption: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "กรุณาป้อนชื่อรูปแบบ", // i18n-ignore: translated by FormComponent
    disable: false,
    section: "information",
  },
  {
    label: "ผู้ตรวจสอบคำร้องขอลา", // i18n-ignore: translated by FormComponent
    name: "auditor_empmloyee_id",
    placeholder: "ป้อนผู้ตรวจสอบคำร้องขอลา", // i18n-ignore: translated by FormComponent
    type: "autocomplete",
    typeForm: "text",
    formSize: "small",
    optionName: "employee",
    defaultOption: "id_employee",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "กรุณาป้อนผู้ตรวจสอบคำร้องขอลา", // i18n-ignore: translated by FormComponent
    disable: false,
    section: "information",
  },
  {
    label: "ตำแหน่งงาน", // i18n-ignore: translated by FormComponent
    name: "auditor_empmloyee_position",
    placeholder: "ป้อนตำแหน่งงาน", // i18n-ignore: translated by FormComponent
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    defaultOption: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "กรุณาป้อนตำแหน่งงาน", // i18n-ignore: translated by FormComponent
    disable: true,
    section: "information",
  },
  {
    label: "ผู้อนุมัติคำร้องขอลา", // i18n-ignore: translated by FormComponent
    name: "approve_empmloyee_id",
    placeholder: "ป้อนผู้อนุมัติคำร้องขอลา", // i18n-ignore: translated by FormComponent
    type: "autocomplete",
    typeForm: "text",
    formSize: "small",
    optionName: "employee",
    defaultOption: "id_employee",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "กรุณาป้อนผู้อนุมัติคำร้องขอลา", // i18n-ignore: translated by FormComponent
    disable: false,
    section: "information",
  },
  {
    label: "ตำแหน่งงาน", // i18n-ignore: translated by FormComponent
    name: "approve_empmloyee_position",
    placeholder: "ป้อนตำแหน่งงาน", // i18n-ignore: translated by FormComponent
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    defaultOption: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "กรุณาป้อนตำแหน่งงาน", // i18n-ignore: translated by FormComponent
    disable: true,
    section: "information",
  },
  {
    label: "รูปแบบฟอร์ม", // i18n-ignore: translated by FormComponent
    name: "leave_type_form_template",
    placeholder: "ป้อนรูปแบบฟอร์ม", // i18n-ignore: translated by FormComponent
    type: "select",
    typeForm: "text",
    formSize: "small",
    optionName: "leave_form",
    defaultOption: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 6 },
    isRequired: false,
    titleRequired: "กรุณาป้อนรูปแบบฟอร์ม", // i18n-ignore: translated by FormComponent
    disable: false,
    section: "information",
  },
  {
    label: "หมวดหมู่การลา", // i18n-ignore: translated by FormComponent
    name: "category",
    placeholder: "เลือกหมวดหมู่การลา", // i18n-ignore: translated by FormComponent
    type: "select",
    typeForm: "text",
    formSize: "small",
    optionName: "leave_type_category",
    defaultOption: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 6 },
    isRequired: false,
    titleRequired: "กรุณาเลือกหมวดหมู่การลา", // i18n-ignore: translated by FormComponent
    disable: false,
    section: "information",
    // แสดง field นี้เฉพาะเมื่อรูปแบบฟอร์มที่เลือกมีคำว่า "อาพาธ" (คือ "ใบลาอาพาธ/ป่วย ลากิจ ลาคลอดบุตร")
    visibleWhenLeaveFormIncludes: "อาพาธ", // i18n-ignore
  },
  {
    label: "การสะสมวันลาข้ามปี", // i18n-ignore: translated by FormComponent
    name: "leave_days_across_years",
    placeholder: "ป้อนการสะสมวันลาข้ามปี", // i18n-ignore: translated by FormComponent
    type: "select",
    typeForm: "text",
    formSize: "small",
    optionName: "status",
    defaultOption: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "กรุณาป้อนการสะสมวันลาข้ามปี", // i18n-ignore: translated by FormComponent
    disable: false,
    section: "information",
  },
];

export default generateFormLeaveType;
